'use client';
import React, { useState, useEffect } from 'react';

export default function UGCHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Features', href: '#features' },
    { label: 'Showcase', href: '#showcase' },
    { label: 'Pricing', href: '#pricing' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-[#080810]/90 backdrop-blur-xl border-b border-white/5'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        {/* Logo */}
        <a href="#" className="flex items-center gap-2 group">
          <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-violet-500 to-purple-700 flex items-center justify-center">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M7 1L13 4V10L7 13L1 10V4L7 1Z" fill="white" fillOpacity="0.9" />
            </svg>
          </div>
          <span className="font-sans font-semibold text-white tracking-tight text-sm">
            AI UGC Studio<span className="text-violet-400 text-[10px] align-super ml-0.5">™</span>
          </span>
        </a>

        {/* Nav */}
        <nav className="hidden md:flex items-center gap-10">
          {navLinks?.map((link) => (
            <a
              key={link?.href}
              href={link?.href}
              className="font-sans text-sm text-white/50 hover:text-white transition-colors duration-200"
            >
              {link?.label}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <a
          href="#pricing"
          className="hidden md:inline-flex items-center gap-2 font-sans text-sm font-medium px-5 py-2.5 rounded-full bg-violet-600 hover:bg-violet-500 text-white transition-all duration-300 shadow-lg shadow-violet-900/40"
        >
          Get Instant Access
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M3 7H11M8 4L11 7L8 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </a>

        {/* Mobile toggle */}
        <button
          className="md:hidden text-white/60 hover:text-white transition-colors"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
            {menuOpen ? (
              <path d="M5 5L17 17M17 5L5 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            ) : (
              <>
                <path d="M4 7H18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 11H18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 15H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
              </>
            )}
          </svg>
        </button>
      </div>
      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#080810]/95 backdrop-blur-xl border-t border-white/5 px-6 py-6 flex flex-col gap-5">
          {navLinks?.map((link) => (
            <a
              key={link?.href}
              href={link?.href}
              onClick={() => setMenuOpen(false)}
              className="font-sans text-sm text-white/60 hover:text-white transition-colors"
            >
              {link?.label}
            </a>
          ))}
          <a
            href="#pricing"
            onClick={() => setMenuOpen(false)}
            className="inline-flex items-center justify-center gap-2 font-sans text-sm font-medium px-5 py-3 rounded-full bg-violet-600 text-white"
          >
            Get Instant Access
          </a>
        </div>
      )}
    </header>
  );
}
